// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"ff47b197","209":"4efbdbaa","267":"4efbdbaa","899":"4efbdbaa"}[chunkId] + ".chunk.css";
};